import { ObjectHelpers } from "../../helpers/object-helpers";
import { StringHelpers } from "../../helpers/string-helpers";
import { IndicatorColorType } from "../data-point/ti-indicator-data.model";
import { IndicatorType } from "../enum/indicator-type.enum";

export class ManageIndicatorModel {
    public indicatorType = IndicatorType.Volume;
    public id = StringHelpers.newGuid();
    public name = '';
    public targetChartArea = 'NewChartArea';
    public colorTypeOne = IndicatorColorType.One;
    public colorOne = 'green';
    public upColorOne = 'green';
    public downColorOne = 'red';
    public colorTypeTwo = IndicatorColorType.One;
    public colorTwo = 'green';
    public upColorTwo = 'green';
    public downColorTwo = 'red';
    public colorTypeThree = IndicatorColorType.One;
    public colorThree = 'green';
    public upColorThree = 'green';
    public downColorThree = 'red';
    public highChartIndicator = false;
    
    public valueOne: number | null = null;
    public valueTwo: number | null = null;
    public gridData: any = [];

    constructor(data?: any) {
        if (data) {
            ObjectHelpers.setProperties(data, this, true);

            if (this.indicatorType == IndicatorType.HighChartStochastic
                || this.indicatorType == IndicatorType.HighChartAD
                || this.indicatorType == IndicatorType.HighChartCCI
                || this.indicatorType == IndicatorType.HighChartIKH
                || this.indicatorType == IndicatorType.HighChartMFI
                || this.indicatorType == IndicatorType.HighChartPivotPoints
                || this.indicatorType == IndicatorType.HighChartVolume) {
                this.highChartIndicator = true;
            }
        }
    }
}